import { useDecision } from '@optimizely/react-sdk'

import { EXPERIMENT_KEY_MENU_EXPERIENCE_PAGE } from 'routes/Menu/constants/experiments'

export const useIsMenuExperiencePageEnabled = () => {
  const [featureFlagDecision] = useDecision(EXPERIMENT_KEY_MENU_EXPERIENCE_PAGE)

  return featureFlagDecision?.variationKey === 't1'
}
